module.exports = __webpack_public_path__ + "img/slink-logos.feb171e2.jpeg";